export default __webpack_public_path__ + "static/media/cert_2019.03b7799c.png";